<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    persistent 
    class="custom-modal"
    v-if="dialog"
  >
    <v-card>
      <v-card-title class="headline">{{ options.title }}</v-card-title>

      <v-card-text>
        {{ options.message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="darken-1"
          flat="flat"
          @click="close()"
        >
          {{options.negativeButton.message}}
        </v-btn>

        <v-btn
          color="green darken-1"
          flat="flat"
          @click="options.positiveButton.onClick"
        >
          {{options.positiveButton.message}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ModalContent',
  props: [],
  data () {
    return {

    }
  },
  created() {
  },
  methods: {
    close () {
      this.$store.dispatch('_modal/close');
    }
  },
  computed: {
    options () {
      return this.$store.state._modal.modalOptions;
    },
    dialog() {
      return this.$store.state._modal.dialog;
    }
  }
    
}
</script>
<style>
.custom-modal .v-dialog__content {
  z-index: 999 !important;
  background-color: #21212175 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/modal.vue